import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { API_BASE_URL} from "./clients/baseclient";
import { environment } from "../environment/environment";
import { AnonymousGuard, AuthGuard, JwtInterceptor, IRoleGuard,RefreshTokenInterceptor } from './Authentication/authentication';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ConfirmdialogComponent } from './modules/components/confirmdialog/confirmdialog.component';
import { HomeComponent } from './modules/home-pages/home/home.component';
import { JoinUsComponent } from './modules/home-pages/join-us/join-us.component';
import { ServiceWorkerModule } from '@angular/service-worker';


@NgModule({
  
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    ConfirmdialogComponent,
  ],
  imports: [
    
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ToastrModule.forRoot({
      //positionClass: "toast-center",
      maxOpened: 2,
      preventDuplicates: true,
      positionClass:'toast-bottom-right'
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      // Register the ServiceWorker as soon as the application is stables
      // or after 30 seconds (whichever comes first).registerImmediately, registerWhenStable:60000
      registrationStrategy: 'registerImmediately'
    }),
  ],
  providers: [{ provide: API_BASE_URL, useValue: environment.apiUrl },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    AuthGuard,
    
   
    AnonymousGuard,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
